import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Alert, Box, Button, Snackbar, Theme, SxProps } from '@mui/material';

const {
  modules: {
    accountSettings: {
      family: {
        sections: {
          invites: { submit, submitLoading, addAnother, invitesSent, invitesFailed },
        },
      },
    },
  },
} = appStrings;

type InviteMembersButtonGroupProps = Readonly<{
  showSuccessMessage: boolean;
  setShowSuccessMessage: (showSuccessMessage: boolean) => void;
  addNewInvite: () => void;
  isLoading: boolean;
  remainingSeats: number;
  showErrorMessage: boolean;
  setShowErrorMessage: (showErrorMessage: boolean) => void;
}>;

export const InviteMembersButtonGroup = ({
  showSuccessMessage,
  setShowSuccessMessage,
  addNewInvite,
  isLoading,
  remainingSeats,
  showErrorMessage,
  setShowErrorMessage,
}: InviteMembersButtonGroupProps) => {
  return (
    <>
      <Box sx={buttonContainerSx}>
        <Button
          id="invite-members-add-another-button"
          type="button"
          onClick={addNewInvite}
          disabled={isLoading || remainingSeats <= 0}
          hierarchy="Tertiary color"
          size="md"
          startIcon={<AppIcon iconName="Plus" diameter="20px" color="currentColor" />}
          sx={buttonSx}
        >
          {addAnother}
        </Button>
        <Button
          id="invite-members-submit-button"
          type="submit"
          disabled={isLoading || remainingSeats < 0}
          hierarchy="Primary"
          size="md"
          icon={isLoading ? 'Leading' : 'Default'}
          startIcon={<AppIcon iconName="Mail01" diameter="20px" color="currentColor" />}
        >
          {isLoading ? submitLoading : submit}
        </Button>
      </Box>
      <Snackbar
        open={showSuccessMessage}
        autoHideDuration={5000}
        onClose={() => setShowSuccessMessage(false)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert severity="success" icon={false}>
          {invitesSent}
        </Alert>
      </Snackbar>
      <Snackbar
        open={showErrorMessage}
        autoHideDuration={5000}
        onClose={() => setShowErrorMessage(false)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert severity="error" icon={false}>
          {invitesFailed}
        </Alert>
      </Snackbar>
    </>
  );
};

const buttonContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: backrs.spacing['spacing-xl'],
});

const buttonSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Gray/600'],
  '&:hover': {
    backgroundColor: backrs.colors['Colors/Base/Transparent'],
    color: backrs.colors['Gray/700'],
  },
  '&.Mui-disabled': {
    color: backrs.colors['Colors/Foreground/fg-disabled'],
    backgroundColor: backrs.colors['Colors/Base/Transparent'],
    border: 'none',
  },
});
